// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAjbvQWPJMaG7dBqjju5hTObSHvkyUjRvk",
  authDomain: "react-http-29978.firebaseapp.com",
  databaseURL: "https://react-http-29978-default-rtdb.firebaseio.com",
  projectId: "react-http-29978",
  storageBucket: "react-http-29978.appspot.com",
  messagingSenderId: "170667549714",
  appId: "1:170667549714:web:5bd21eb37136c6d0c2e4cb"
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);
export const storage = getStorage(firebaseApp);